/******************************************************************************
 *** BgtOvrlGrnamtViewDialog ** 총괄조합비 * 지출결의서 상세정보 * 교부금 상세내역 조회 모달
*******************************************************************************/
import React from "react";
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Util from "@/js/common/Util";
import Button from "@/js/common/ui/Button";

interface Props {
    ovrlMbsdsExpndDocId: string;
    setModalOpen: Function;
    setCallTime?: Function;
}

const BgtOvrlGrnamtViewDialog = ({ ovrlMbsdsExpndDocId, setModalOpen, setCallTime }: Props) => {
  const [dataArr, setDataArr] = React.useState<any[]>([]);

  // 합계(서버가 내려주는 값 그대로)
  const [sumMbsdsSumAmt, setSumMbsdsSumAmt] = React.useState<string>("0"); // 조합비 합계
  const [sumOperAmt    , setSumOperAmt    ] = React.useState<string>("0"); // 운영금(본부비) 합계
  const [sumDtbnAmt    , setSumDtbnAmt    ] = React.useState<string>("0"); // 교부금(지방본부비) 합계

    // 조회
    React.useEffect(() => {
        if (Util.isEmpty(ovrlMbsdsExpndDocId)) return;

        AppContext.showSpinner();
        Axios.dataAccess({
            url: "system/bgt/ovrl/expnd/select-ovrl-grnamt-list.do",
            methodType: "post",
            paramType: "json",
            paramData: {
                ovrlMbsdsExpndDocId: ovrlMbsdsExpndDocId
            },
            onSuccessFn: (res: any) => {
                const list = res.result.list;
                const sum = res.result.listSum;

                setDataArr(list);
                setSumMbsdsSumAmt(sum.sumMbsdsSumAmt); // 조합비 합계
                setSumOperAmt    (sum.sumOperAmt    ); // 운영금(본부비) 합계
                setSumDtbnAmt    (sum.sumDtbnAmt    ); // 교부금(지방본부비) 합계

                AppContext.hideSpinner();
            },
        });
    }, [ovrlMbsdsExpndDocId]);

    return (
        <div className="w100p dpFlx jcC">
            <div style={{width: "820px"}} className="p10">
                <div className="mb10 dpFlx jcSb">
                    <div>
                        <span className="fm-b fs16 fc007bff ls1 fw700">교부금 배정 상세내용</span>
                    </div>
                </div>
                <div className="bd1 bdcEDEDED bdrd2 ofH">
                    <table className="w100p tbl-collapse tlF">
                        <colgroup>
                            <col className="w140" /> {/* 지방본부별 */}
                            <col className="w120" /> {/* 조합비총액 */}
                            <col className="w50"  /> {/* 운영 % */}
                            <col className="w120" /> {/* 운영 금액 */}
                            <col className="w50"  /> {/* 교부 % */}
                            <col className="w120" /> {/* 교부 금액 */}
                            <col className="w150" /> {/* 비고 */}
                        </colgroup>
                        <thead>
                            <tr className="h25">
                                <th rowSpan={2} className="bd1 bdcDFDFDF bgcF1F8FF taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">지방본부별</span>
                                </th>
                                <th rowSpan={2} className="bd1 bdcDFDFDF bgcF1F8FF taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">조합비총액</span>
                                </th>
                                <th colSpan={2} className="bd1 bdcDFDFDF bgcE8EEFF taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">운영금(본부비)</span>
                                </th>
                                <th colSpan={2} className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">교부금(지방본부비)</span>
                                </th>
                                <th rowSpan={2} className="bd1 bdcDFDFDF bgcF1F8FF taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc2c3e50 wsNw">비고</span>
                                </th>
                            </tr>
                            <tr className="h25">
                                <th className="bd1 bdcDFDFDF bgcE8EEFF taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc777777 wsNw">%</span>
                                </th>
                                <th className="bd1 bdcDFDFDF bgcE8EEFF taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc777777 wsNw">금액</span>
                                </th>
                                <th className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc777777 wsNw">%</span>
                                </th>
                                <th className="bd1 bdcDFDFDF bgcfcf1e1 taC fw700">
                                    <span className="dpFlx aiC jcC fs13 fc777777 wsNw">금액</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {dataArr.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="bd1 bdcEDEDED">
                                        <div className="h44 dpFlx aiC jcC fc999999 fm-c fs13">조회된 데이터가 없습니다.</div>
                                    </td>
                                </tr>
                            ) : (
                                dataArr.map((row: any, index: number) => {
                                const zebraBg = index % 2 === 0 ? "bgcWhite" : "bgcF9F9F9";

                                return (
                                    <tr key={index} className={zebraBg} style={{height: "38px"}}>
                                        {/* 지방본부 */}
                                        <td className="bd1 bdcEDEDED">
                                            <span className="dpFlx aiC pw12 fm-c fs13 fc333333 wsNw ofH toE jcC">{row.grnamtOrgNm}</span>
                                        </td>
                                        {/* 조합비총액 */}
                                        <td className="bd1 bdcEDEDED">
                                            <span className="dpFlx aiC jcE pw12 fm-b fs13 fc333333">
                                                {Util.comma(String(row.mbsdsSumAmt ?? "0"))}
                                            </span>
                                        </td>
                                        {/* 운영% */}
                                        <td className="bd1 bdcEDEDED">
                                            <span className="dpFlx aiC jcC pw8 fm-b fs13 fc333333">{String(row.operRt ?? "0")}</span>
                                        </td>

                                        {/* 운영금액 */}
                                        <td className="bd1 bdcEDEDED">
                                            <span className="dpFlx aiC jcE pw12 fm-b fs13 fc333333">
                                                {Util.comma(String(row.operAmt ?? "0"))}
                                            </span>
                                        </td>

                                        {/* 교부% */}
                                        <td className="bd1 bdcEDEDED">
                                            <span className="dpFlx aiC jcC pw8 fm-b fs13 fc333333">{String(row.dtbnRt ?? "0")}</span>
                                        </td>

                                        {/* 교부금액 */}
                                        <td className="bd1 bdcEDEDED">
                                            <span className="dpFlx aiC jcE pw12 fm-b fs13 fc333333">
                                                {Util.comma(row.dtbnAmt ?? "0")}
                                            </span>
                                        </td>

                                        {/* 비고 */}
                                        <td className="bd1 bdcEDEDED">
                                            <span className="dpFlx aiC pw12 fm-c fs13 fc333333 wsNw ofH toE">
                                                {String(row.rmrkCn ?? "")}
                                            </span>
                                        </td>
                                    </tr>
                                );
                                })
                            )}
                        </tbody>
                        <tfoot>
                        {/* 합계 row */}
                            <tr className="bgcF1F8FF h38">
                                <td className="bd1 bdcEDEDED">
                                    <span className="dpFlx aiC jcC pw12 fm-c fs13 fc111111">합계</span>
                                </td>
                                <td className="bd1 bdcEDEDED">
                                    <span className="dpFlx aiC jcE pw12 fm-c fs13 fc007bff">{Util.comma(sumMbsdsSumAmt)}</span>
                                </td>
                                <td className="bd1 bdcEDEDED">
                                    <span className="dpFlx aiC jcC pw8 fm-c fs12 fc666666"></span>
                                </td>
                                <td className="bd1 bdcEDEDED">
                                    <span className="dpFlx aiC jcE pw12 fm-c fs13 fc111111">{Util.comma(sumOperAmt)}</span>
                                </td>
                                <td className="bd1 bdcEDEDED">
                                    <span className="dpFlx aiC jcC pw8 fm-c fs12 fc666666"></span>
                                </td>
                                <td className="bd1 bdcEDEDED">
                                    <span className="dpFlx aiC jcE pw12 fm-c fs13 fc111111">{Util.comma(sumDtbnAmt)}</span>
                                </td>
                                <td className="bd1 bdcEDEDED">
                                    <span className="dpFlx aiC jcC pw12 fm-c fs13 fc666666"></span>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                {/* 버튼(닫기만) */}
                <div className="dpFlx aiC jcC gap10 mt20">
                    <Button buttonName="닫기"
                        width={120} height={40}
                        fontFamily="fm-b" fontSize={15} letterSpacing={-0.8} 
                        variant="styCloseBtn" borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        onClickFunc={() => setModalOpen(false)}
                    />
                </div>
            </div>
        </div>
    );
};

export default BgtOvrlGrnamtViewDialog;
